// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"ea19d0cb","285":"3638562c","787":"ca822a80","973":"17ec1bde"}[chunkId] + ".chunk.js";
};